import * as React from 'react';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CheckinOrderFragment, TravellerFieldEnum, useGetCheckinOrderQuery } from '@websky/graphql';
import { fillCheckinOrder } from '../../store/order/actions';
import OrderGuard from '../../../../OrderGuard/OrderGuard';
import Order from './Order/Order';
import { getCheckinOrder } from '../../store/order/selectors';
import CheckinErrorBoundary from './CheckinErrorBoundary/CheckinErrorBoundary';
import { useCheckinRestrictions, useUpdateCheckinTravellerServices } from '../../hooks';
import { getUserValue } from '../../../../utils';

interface Props {
	orderId: string;
}

const OrderWrapper: React.FC<Props> = ({ orderId }) => {
	const dispatch = useDispatch();

	const order = useSelector(getCheckinOrder);

	const onOrderAccessGranted = useCallback(() => window.location.reload(), []);

	let lastName: string;
	let ticketNumber: string;

	if (order && order.travellers.length) {
		lastName = getUserValue(order.travellers[0], TravellerFieldEnum.LastName);
		ticketNumber = order.travellers[0]?.tickets?.[0]?.number;
	}

	const orderLoaded = useMemo(() => {
		return !!order && order.id === orderId;
	}, [order, orderId]);

	const onOrderLoad = (order: CheckinOrderFragment) => {
		dispatch(fillCheckinOrder(order));
	};

	useUpdateCheckinTravellerServices();
	useCheckinRestrictions();

	return (
		<OrderGuard<CheckinOrderFragment>
			orderId={orderId}
			orderLoaded={orderLoaded}
			onOrderLoad={onOrderLoad}
			onOrderAccessGranted={onOrderAccessGranted}
			loadOrder={useGetCheckinOrderQuery}
		>
			<CheckinErrorBoundary lastName={lastName} ticketNumber={ticketNumber}>
				<Order />
			</CheckinErrorBoundary>
		</OrderGuard>
	);
};

export default OrderWrapper;
